<template>
	<div class="hide-on-web sidebar-mobile">
		<div class="row" style="padding: 20px 0; background-color: #fffaf4; margin-bottom: 20px;">
			<router-link to="/">
				<img src="/img/Logo.png" alt="Bisa Cek" class="ml-4 group-2 d-block img-fluid">
			</router-link>
			<a href="javascript:;" @click="logout" class=" c-grey f-12 mr-3 mt-4" style="position: absolute; right: 0; top: 0;">Keluar</a>			
		</div>
		<div style="padding: 0px 20px;">
			<h5><strong>Hello, {{name}}</strong></h5>
			<small>Selamat bekerja</small>
			<select class="mx-auto mt-3 mb-3 selectpicker" @change="changeLocation($event)" v-model="key">
				<option value="/dashboard" data-content="<span><img src='/img/icon-3/dashboard.png' height='28px'></option></span> Halaman Utama">Halaman Utama</option>
				<option value="/expedition" data-content="<span><img src='/img/icon-3/trip.png' height='28px'></option></span> Trip">Trip</option>
				<option value="/shipment" data-content="<span><img src='/img/icon-3/shipment.png' height='28px'></option></span> Shipment">Shipment</option>
				<option value="/contact" data-content="<span><img src='/img/icon-3/contact.png' height='28px'></option></span> Kontak Pelanggan">Kontak Pelanggan</option>
				<option value="/price" data-content="<span><img src='/img/icon-3/route_price.png' height='28px'></option></span> Rute &amp; Harga">Rute &amp; Harga</option>
				<option value="/driver" data-content="<span><img src='/img/icon-3/driver.png' height='28px'></option></span> Personel">Personel</option>
				<option value="/device" data-content="<span><img src='/img/icon-3/device.png' height='28px'></option></span> Perangkat Komunikasi">Perangkat Komunikasi</option>
				<option value="/vehicle" data-content="<span><img src='/img/icon-3/vehicle.png' height='28px'></option></span> Kendaraan">Kendaraan</option>
				<option value="/report" data-content="<span><img src='/img/icon-3/report.png' height='28px'></option></span> Laporan">Laporan</option>
				<option value="/setting" data-content="<span><img src='/img/icon-3/setting.png' height='28px'></option></span> Pengaturan">Pengaturan</option>
			</select>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MobileMenu',
	data() {
		return {
			key: '/dashboard',
			name: localStorage.getItem('name')
		}
	},
	methods: {
		changeLocation(event){
			let _ = this
			_.$router.push(event.target.value)	
		},
		logout() {
			let _ = this
			_.$store.dispatch('logout')
			_.$router.push('/')
		}
	},
	mounted(){
		$('select.selectpicker').selectpicker();
	}
}
</script>